import React, { useEffect, useState } from 'react';
import '../../styles/quiz-base.css';
import './resultado.css';
import Footer from '../../components/footer/Footer';

const API_BASE = process.env.REACT_APP_API_BASE;

const Resultado = () => {
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [mostrarDetalhes, setMostrarDetalhes] = useState(false);

  useEffect(() => {
    const fetchResultados = async () => {
      try {
        const res = await fetch(`${API_BASE}/calcular-plano.php`, {
          credentials: 'include'
        });
        const data = await res.json();
        setDados(data);
      } catch (err) {
        console.error('Erro ao carregar dados:', err);
      } finally {
        setTimeout(() => setCarregando(false), 800);
      }
    };

    fetchResultados();
  }, []);

  const interpretarIMC = (imc) => {
    if (imc < 18.5) return 'Abaixo do peso';
    if (imc < 25) return 'Faixa considerada normal';
    if (imc < 30) return 'Acima do peso';
    if (imc < 35) return 'Faixa elevada (I)';
    if (imc < 40) return 'Faixa elevada (II)';
    return 'Faixa elevada (III)';
  };

  const gerarSimulacao = () => {
    if (!dados || !dados.objetivo) return '';

    const variacao = Math.abs(dados.variacao_peso_30dias).toFixed(1);

    if (dados.objetivo === 'emagrecer') {
      return `📉 Estimativa aproximada: −${variacao} kg em 30 dias`;
    }

    if (dados.objetivo === 'ganhar_peso') {
      return `📈 Estimativa aproximada: +${variacao} kg em 30 dias`;
    }

    if (dados.objetivo === 'manter') {
      return `⚖️ Estimativa associada à manutenção do peso atual`;
    }

    return '';
  };

  return (
    <div className="quiz-etapa resultado-page">
      <img src="/assets/logo1.png" alt="Logo NutriFácil" className="quiz-logo" />

      <h2 className="quiz-pergunta">
        Estimativa calórica com base nas informações informadas
      </h2>

      <p className="meta-kcal">
        Valor aproximado de referência por dia:
      </p>

      {carregando ? (
        <div className="resultado-loading">
          <div className="loading-bar"></div>
          <p>Calculando estimativa...</p>
        </div>
      ) : dados ? (
        <>
          <div className="resultado-meta">
            <h1>≈ {dados.calorias_meta} kcal</h1>

            <div className="resultado-simulacao">
              <span className="simulacao">
                {gerarSimulacao()}
              </span>
            </div>
          </div>

          <div className="resultado-acoes">
            <div className="resultado-cta-box">
              <a href="/restricoes" className="quiz-botao ativo">
                Continuar
              </a>
            </div>

            <div className="resultado-acordeao">
              <button
                className="botao-detalhes"
                onClick={() => setMostrarDetalhes(!mostrarDetalhes)}
              >
                {mostrarDetalhes ? 'Ocultar detalhes' : 'Ver mais detalhes'}
              </button>
            </div>
          </div>

          {mostrarDetalhes && (
            <div className="detalhes-bloco">
              <div className="resultado-item">
                <h3>IMC (índice de massa corporal)</h3>
                <p>
                  <strong>{dados.imc}</strong> ({interpretarIMC(dados.imc)})
                </p>
              </div>

              <div className="resultado-item">
                <h3>Taxa Metabólica Basal (TMB)</h3>
                <p>
                  <strong>{dados.tmb} kcal</strong>
                </p>
              </div>

              <div className="resultado-item">
                <h3>Gasto Calórico Total estimado (GCT)</h3>
                <p>
                  <strong>{dados.gct} kcal</strong>
                </p>
              </div>
            </div>
          )}
        </>
      ) : (
        <p>Erro ao carregar resultados.</p>
      )}

      <div className="quiz-footer">
        <Footer />
      </div>
    </div>
  );
};

export default Resultado;
